import { render, staticRenderFns } from "./SaxxSelect.vue?vue&type=template&id=2bd9e8c8"
import script from "./SaxxSelect.vue?vue&type=script&lang=js"
export * from "./SaxxSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports